export enum StorageKey {
    user = "user",
}
